<template>
  <div id="inbound_call_availability" class="flex flex-col gap-6">
    <span class="text-base font-semibold text_color">Calls</span>
    <div class="flex flex-row gap-2">
      <a-switch
        class="w-fit my-1"
        size="small"
        v-model:checked="inboundAvailability"
        @change="toUpdateCallAvailability"
      />

      <div class="flex flex-col">
        <span class="text-sm font-semibold">Inbound call availability</span>
        <span class="text-xs secondary_color"
          >Disabling this will turn off all inbound calls</span
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import CallService from "@/src/api/CallService.js";
import { message } from "ant-design-vue";

const inboundAvailability = ref(false);

const toFetchCallAvailability = async () => {
  try {
    const response = await CallService.fetchCallAvailability();
    if (response?.success) {
      inboundAvailability.value = response?.call_available;
    }
  } catch (error) {
    console.error(
      "An error occurred while fetching call availability: ",
      error,
    );
  }
};

const toUpdateCallAvailability = async () => {
  try {
    const payload = {
      available: inboundAvailability.value,
    };

    const response = await CallService.updateCallAvailability(payload);
    if (response?.success) {
      inboundAvailability.value = response?.call_available;
      message.success(
        `Inbound call availability ${inboundAvailability.value ? "enabled" : "disabled"}`,
      );
    }
  } catch (error) {
    console.error(
      "An error occurred while updating call availability: ",
      error,
    );
    message.error("An error occurred while updating call availability");
  }
};

onMounted(() => {
  toFetchCallAvailability();
});
</script>
